const baseJson = () => {
  return {
    _id: null,
    name: null,
    nameEn: null,
    unsignedName: null,
    code: null,
    sort: 0,
    tenKhoaHoc: null,
    dacTinhSinhHoc: null,
    dacTinhSinhHocEn: null,
    dienTichSanLuong: null,
    dienTichSanLuongEn: null,
    vungTrongTapTrung: null,
    vungTrongTapTrungEn: null,
    moTa: null,
    moTaEn: null,
    avatar: null,
    qrCode2: null,
    files: [],
    thuocTinhs: [], // Bổ sung mảng thuộc tính động lồng nhau
    fileGhiChu: [], // Bổ sung mảng tài liệu/báo cáo đính kèm
    infographics: [],
    chungNhan: [], // Mảng danh sách chứng nhận động (Singular)
    ghiChu: null,
    ghiChuEn: null,
    view: 0,
    createdAt: null,
    modifiedAt: null,
    createdBy: null,
    modifiedBy: null,
    isDeleted: false,
    createdAtShow: null,
    lastModifiedShow: null,
    createdAtString: null,
  };
};

const toJson = (item) => {
  if (!item) return baseJson();

  return {
    _id: item._id,
    name: item.name,
    nameEn: item.nameEn || null,
    unsignedName: item.unsignedName || null,
    code: item.code || null,
    sort: Number(item.sort) || 0,
    tenKhoaHoc: item.tenKhoaHoc || null,
    dacTinhSinhHoc: item.dacTinhSinhHoc || null,
    dacTinhSinhHocEn: item.dacTinhSinhHocEn || null,
    dienTichSanLuong: item.dienTichSanLuong || null,
    dienTichSanLuongEn: item.dienTichSanLuongEn || null,
    vungTrongTapTrung: item.vungTrongTapTrung || null,
    vungTrongTapTrungEn: item.vungTrongTapTrungEn || null,
    moTa: item.moTa || null,
    moTaEn: item.moTaEn || null,
    avatar: item.avatar
      ? {
          fileId: item.avatar.fileId,
          fileName: item.avatar.fileName,
          ext: item.avatar.ext,
          path: item.avatar.path,
        }
      : null,
    qrCode2: item.qrCode2
      ? {
          fileId: item.qrCode2.fileId,
          fileName: item.qrCode2.fileName,
          ext: item.qrCode2.ext,
          path: item.qrCode2.path,
        }
      : null,
    files: Array.isArray(item.files)
      ? item.files.map((f) => ({
          fileId: f.fileId,
          fileName: f.fileName,
          ext: f.ext,
          path: f.path,
        }))
      : [],
    // Đồng bộ hóa cấu trúc lồng sâu của mảng thuộc tính động khi đẩy lên API
    thuocTinhs: Array.isArray(item.thuocTinhs)
      ? item.thuocTinhs.map((group) => ({
          key: group.key || null,
          keyEn: group.keyEn || null,
          index: Number(group.index) || 0,
          Value: Array.isArray(group.Value || group.value)
            ? (group.Value || group.value).map((v) => ({
                index: Number(v.index) || 0,
                name: v.name || null,
                nameEn: v.nameEn || null,
                tieuDe: v.tieuDe || null,
                tieuDeEn: v.tieuDeEn || null,
                value: v.value || null,
                valueEn: v.valueEn || null,
                files: Array.isArray(v.files)
                  ? v.files.map((img) => ({
                      fileId: img.fileId,
                      fileName: img.fileName,
                      ext: img.ext,
                      path: img.path,
                    }))
                  : [],
              }))
            : [],
        }))
      : [],
    // Đồng bộ hóa danh sách tài liệu đính kèm khi đẩy lên API
    fileGhiChu: Array.isArray(item.fileGhiChu)
      ? item.fileGhiChu.map((doc) => ({
          fileId: doc.fileId,
          fileName: doc.fileName,
          ext: doc.ext,
          path: doc.path,
        }))
      : [],
    infographics: Array.isArray(item.infographics)
      ? item.infographics.map((f) => ({
          fileId: f.fileId,
          fileName: f.fileName,
          ext: f.ext,
          path: f.path,
        }))
      : [],
    chungNhan: Array.isArray(item.chungNhan)
      ? item.chungNhan.map((cn) => ({
          key: cn.key || null,
          keyEn: cn.keyEn || null,
          index: cn.index !== undefined ? cn.index : null,
          files: Array.isArray(cn.files)
            ? cn.files.map((f) => ({
                fileId: f.fileId,
                fileName: f.fileName,
                ext: f.ext,
                path: f.path,
              }))
            : [],
          isBool: cn.isBool === true,
        }))
      : [],
    ghiChu: item.ghiChu || null,
    ghiChuEn: item.ghiChuEn || null,
    view: Number(item.view) || 0,
    createdAt: item.createdAt || null,
    modifiedAt: item.modifiedAt || null,
    createdBy: item.createdBy || null,
    modifiedBy: item.modifiedBy || null,
    isDeleted: item.isDeleted || false,
    createdAtShow: item.createdAtShow || null,
    lastModifiedShow: item.lastModifiedShow || null,
    createdAtString: item.createdAtString || null,
  };
};

const fromJson = (item) => {
  if (!item) return baseJson();
  return {
    _id: item._id,
    name: item.name || null,
    nameEn: item.nameEn || null,
    unsignedName: item.unsignedName || null,
    code: item.code || null,
    sort: item.sort || 0,
    tenKhoaHoc: item.tenKhoaHoc || null,
    dacTinhSinhHoc: item.dacTinhSinhHoc || null,
    dacTinhSinhHocEn: item.dacTinhSinhHocEn || null,
    dienTichSanLuong: item.dienTichSanLuong || null,
    dienTichSanLuongEn: item.dienTichSanLuongEn || null,
    vungTrongTapTrung: item.vungTrongTapTrung || null,
    vungTrongTapTrungEn: item.vungTrongTapTrungEn || null,
    moTa: item.moTa || null,
    moTaEn: item.moTaEn || null,
    avatar: item.avatar || null,
    qrCode2: item.qrCode2 || null,
    files: Array.isArray(item.files) ? item.files : [],
    // Bản đồ hóa cấu trúc lồng sâu an toàn khi nhận từ API trả về
    thuocTinhs: Array.isArray(item.thuocTinhs)
      ? item.thuocTinhs.map((group) => ({
          key: group.key || "",
          keyEn: group.keyEn || "",
          index: group.index || 0,
          Value: Array.isArray(group.Value || group.value)
            ? (group.Value || group.value).map((v) => ({
                index: v.index || 0,
                name: v.name || "",
                nameEn: v.nameEn || "",
                tieuDe: v.tieuDe || "",
                tieuDeEn: v.tieuDeEn || "",
                value: v.value || "",
                valueEn: v.valueEn || "",
                files: Array.isArray(v.files) ? v.files : [],
              }))
            : [],
        }))
      : [],
    // Bản đồ hóa mảng file tài liệu khi nhận từ API
    fileGhiChu: Array.isArray(item.fileGhiChu) ? item.fileGhiChu : [],
    infographics: Array.isArray(item.infographics) ? item.infographics : [],
    chungNhan: Array.isArray(item.chungNhan)
      ? item.chungNhan.map((cn) => ({
          key: cn.key || "",
          keyEn: cn.keyEn || "",
          index: cn.index !== undefined ? cn.index : null,
          files: Array.isArray(cn.files) ? cn.files : [],
          isBool: cn.isBool === true,
        }))
      : [],

    ghiChu: item.ghiChu || null,
    ghiChuEn: item.ghiChuEn || null,
    view: item.view || 0,
    createdAt: item.createdAt || null,
    modifiedAt: item.modifiedAt || null,
    createdBy: item.createdBy || null,
    modifiedBy: item.modifiedBy || null,
    isDeleted: item.isDeleted || false,
    createdAtShow: item.createdAtShow || null,
    lastModifiedShow: item.lastModifiedShow || null,
    createdAtString: item.createdAtString || null,
  };
};

export const traiCayModel = {
  baseJson,
  fromJson,
  toJson,
};
